import React, { useMemo, useState } from 'react'
import { Milestone } from '../../../../types/collaborations/CollaborationTypes'
import { Campaign } from '../../../../types/sponsorships/campaigns'
import MilestonePayoutPNG from "../../../../assets/images/milestone-payouts.png"
import MilestoneMediaPNG from "../../../../assets/images/milestone-media.png"
import { getMediaTypeFromURL, toValidNumber } from '../../../../utils/helpers'
import InstagramReelIconPNG from '../../../../assets/images/icons/instagram-reel.png'
import { acknowledgeMilestone } from '../../../../services/api/collaboration'
import { useParams } from 'react-router-dom'
import ExpandableWYSIWYGPreview from '../../../ExpandableWYSIWYGPreview'
import { POSTAPIError } from '../../../../types'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux-stores/store'
import HTMLContent from '../../../HTMLContent'
interface SpecificationsProps {
    activeMilestone: Milestone,
    campaign: Campaign,
    acknowledgementRequired?: boolean,
    onAcknowledgement: (ack: boolean) => void,
    showDisabledTooltip?: boolean,
    setSelectedMedia: (post: any) => void,
    onAcknowledgementError: (error: POSTAPIError) => void,
    setConnectionRequiredModalVisibility: (visible: boolean) => void
}

const Specifications: React.FC<SpecificationsProps> = ({ activeMilestone, campaign, showDisabledTooltip, acknowledgementRequired = false, onAcknowledgement, setSelectedMedia, onAcknowledgementError, setConnectionRequiredModalVisibility }) => {

    const [acknowledged, setAcknowledged] = useState(false);
    const { campaignId, milestoneId } = useParams();
    const [acknowledging, setAcknowledging] = useState(false);
    const collaboration = useSelector((state: RootState) => state.collaborationDetails.collaborations[campaignId!]?.collaborationData);


    const connectionRequired = useSelector((state: RootState) => state.influencer.connectionRequired);


    const samplePosts = useMemo(() => {
        const campaignFiles = Array.isArray(activeMilestone?.campaign_files) ? activeMilestone.campaign_files : [];

        return campaignFiles.filter((campaignFile) => campaignFile.type === 'sample_post');
    }, [activeMilestone.campaign_files])

    const creatives = useMemo(() => {
        const campaignFiles = Array.isArray(activeMilestone?.campaign_files) ? activeMilestone.campaign_files : [];

        return campaignFiles.filter((campaignFile) => campaignFile.type === 'creative');
    }, [activeMilestone.campaign_files])

    const acknowledge = async () => {
        if (!campaignId || !milestoneId || !acknowledged) return;

        if (connectionRequired)
            return setConnectionRequiredModalVisibility(true);

        try {
            setAcknowledging(true);
            await acknowledgeMilestone(campaignId, milestoneId);
            onAcknowledgement(true);
        } catch (error: any) {
            console.log(error);
            if (error?.response?.data) {
                onAcknowledgementError(error.response.data)
            }

        } finally {
            setAcknowledging(false);
        }
    }


    return (
        <div className='position-relative d-flex flex-column gap-3'>
            <div className="app-card">
                <h6 className="fs-16 text-dark fw-600">{campaign.name}</h6>
                <div className='fs-14 text-dark-gray fw-400'>
                    <HTMLContent content={activeMilestone?.brief ?? ''} />
                </div>
            </div>
            {
                (!activeMilestone?.specifications?.quick_repost) &&
                <div className="app-card">
                    <div className="specification-card-header">
                        <h6 className="fs-16 text-dark fw-600">Media Requirements</h6>
                        <img src={MilestoneMediaPNG} className='milestone-spec-illustrator' alt='milestone-payout' />
                    </div>
                    <div className='specification-card-content'>
                        <div className="milestone-media-requirements">
                            {
                                collaboration?.collaboration?.platform === 'ig' &&
                                <>
                                    <div className="milestone-media-requirement bg-white">
                                        <span>{activeMilestone.content_media_types.REELS}</span>
                                        <span>Reel</span>
                                    </div>
                                    <div className="milestone-media-requirement bg-white">
                                        <span>{activeMilestone.content_media_types.STORY}</span>
                                        <span>Story</span>
                                    </div>
                                    <div className="milestone-media-requirement bg-white">
                                        <span>{activeMilestone.content_media_types.FEED}</span>
                                        <span>Post</span>
                                    </div>
                                </>
                            }
                            {
                                collaboration?.collaboration?.platform === 'yt' &&
                                <div className="milestone-media-requirement bg-white">
                                    <span>{activeMilestone.content_media_types.VIDEO}</span>
                                    <span>Video</span>
                                </div>
                            }
                        </div>
                        <div className="milestone-media-requirements">
                            {
                                activeMilestone.payment_days &&
                                <div className="milestone-media-requirement bg-white">
                                    <span>{activeMilestone.payment_days} <span className="subtext">day{activeMilestone.payment_days > 1 ? 's' : ''}</span></span>
                                    <span>Payment</span>
                                </div>
                            }
                            {
                                activeMilestone?.specifications?.content_rights_duration &&
                                <div className="milestone-media-requirement bg-white">
                                    <span>{activeMilestone.specifications.content_rights_duration} <span className='subtext'>month{Number(activeMilestone.specifications.content_rights_duration) > 1 ? 's' : ''}</span></span>
                                    <span>Content Rights</span>
                                </div>
                            }
                            {
                                activeMilestone?.specifications?.ad_rights_duration &&
                                <div className="milestone-media-requirement bg-white">
                                    <span>{activeMilestone.specifications.ad_rights_duration} <span className='subtext'>month{Number(activeMilestone.specifications.ad_rights_duration) > 1 ? 's' : ''}</span></span>
                                    <span>Ad Rights</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
            <div className={`app-card-wrapper position-relative overflow-hidden border-radius-24 ${toValidNumber(activeMilestone?.barter_amount) > 0 ? '' : 'box-shadow-none'}`}>
                <div className={`app-card ${toValidNumber(activeMilestone?.barter_amount) > 0 ? 'box-shadow-none' : ''}`}>
                    <div className="specification-card-header">
                        <h6 className="fs-16 text-dark fw-600">Payout</h6>
                        <img src={MilestonePayoutPNG} className='milestone-spec-illustrator' alt='milestone-payout' />
                    </div>
                    <div className='specification-card-content'>
                        <div className="milestone-media-requirements">
                            <div className="milestone-media-requirement bg-white">
                                <span className='text-success'>₹{activeMilestone.gig_amount}</span>
                                <span>Payout</span>
                            </div>
                            {
                                activeMilestone.barter_amount ?
                                    <div className="milestone-media-requirement bg-white">
                                        <span className='text-success'><span className='upto me-1'>upto</span>₹{activeMilestone.barter_amount}</span>
                                        <span>{activeMilestone?.barter_reimbursement ? 'Reimbursement' : 'Barter'} Amount</span>
                                    </div> : null
                            }
                        </div>
                    </div>
                </div>
                {
                    toValidNumber(activeMilestone?.barter_amount) > 0 &&
                    <div className="px-075 py-2">
                        <span className="fs-12 fw-400 text-dark"></span>
                        {
                            activeMilestone?.barter_reimbursement ? "You will have to buy product and it will be reimbursed by the brand." : "Brand will provide product for free."
                        }
                    </div>
                }
            </div>
            {
                Array.isArray(activeMilestone?.specifications?.talking_points) && activeMilestone.specifications.talking_points.length > 0 &&
                activeMilestone?.specifications?.talking_points.map((talkingPoint, i) => {
                    return (
                        <div className="app-card" key={i}>
                            <h6 className="fs-16 text-dark fw-600">{talkingPoint.title}</h6>
                            <div className='specification-card-content'>
                                <ul className='specification-content-list'>
                                    {
                                        Array.isArray(talkingPoint.pointers) && talkingPoint.pointers.length > 0 &&
                                        talkingPoint.pointers.map((pointer, j) => {
                                            return (
                                                <li className='fs-14 text-dark-gray fw-400' key={j}>
                                                    {pointer}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    )
                })

            }
            {
                Array.isArray(activeMilestone?.specifications?.do) && activeMilestone.specifications.do.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Do(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.do.map((content, i) => {
                                    return (
                                        <li className='fs-14 text-dark-gray fw-400' key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.dont) && activeMilestone.specifications.dont.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Don't(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.dont.map((content, i) => {
                                    return (
                                        <li className='fs-14 text-dark-gray fw-400' key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.must_have) && activeMilestone.specifications.must_have.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Must Have(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.must_have.map((content, i) => {
                                    return (
                                        <li className='fs-14 text-dark-gray fw-400' key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.sample_scripts) && activeMilestone.specifications.sample_scripts.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Sample Scripts</h6>
                    <div className='specification-card-content'>
                        {
                            activeMilestone.specifications.sample_scripts.map((content, i) => {
                                return (
                                    <div className="script-preview fs-14 text-dark-gray fw-400">
                                        <ExpandableWYSIWYGPreview content={content} key={i} />
                                    </div>

                                )
                            })
                        }
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.sample_captions) && activeMilestone.specifications.sample_captions.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Sample Captions</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.sample_captions.map((content, i) => {
                                    return (
                                        <li className='fs-14 text-dark-gray fw-400' key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.hashtags) && activeMilestone.specifications.hashtags.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Hashtag(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.hashtags.map((content, i) => {
                                    return (
                                        <li className='fs-14 text-dark-gray fw-400' key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.mentions) && activeMilestone.specifications.mentions.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Mention(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.mentions.map((content, i) => {
                                    return (
                                        <li className='fs-14 text-dark-gray fw-400' key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                Array.isArray(activeMilestone?.specifications?.collaborators) && activeMilestone.specifications.collaborators.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Collaborator(s)</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            {
                                activeMilestone.specifications.collaborators.map((content, i) => {
                                    return (
                                        <li className='fs-14 text-dark-gray fw-400' key={i}>{content}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            }
            {
                activeMilestone?.specifications?.paid_partnership_label_required && activeMilestone?.specifications?.paid_partnership_handle && activeMilestone?.specifications?.paid_partnership_handle.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Paid Partnership</h6>
                    <div className='specification-card-content'>
                        <ul className='specification-content-list'>
                            <li className='fs-14 text-dark-gray fw-400'>{activeMilestone?.specifications?.paid_partnership_handle[0]}</li>
                        </ul>
                    </div>
                </div>
            }
            {
                creatives.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Creatives</h6>
                    <div className='specification-card-content'>
                        <div className="row mb-0 g-0">
                            {
                                creatives.map((creative, i) => {
                                    return (
                                        <div className="col-6 p-3" key={i}>
                                            {
                                                getMediaTypeFromURL(creative.url) === 'image' ?
                                                    (
                                                        <a href={creative.url} target='_blank' className="d-block creative bg-media bgc-white" style={{
                                                            backgroundImage: `url(${creative.url})`
                                                        }}></a>
                                                    ) : (
                                                        <a href={creative.url} target='_blank' className="d-block creative bg-media bgc-white">
                                                            <video playsInline
                                                                muted
                                                                preload="metadata"
                                                                onLoadedMetadata={(e) => {
                                                                    e.currentTarget.currentTime = 0.1; // force thumbnail frame
                                                                }} src={creative.url} className='d-block w-100 creative bg-media bgc-content' />
                                                        </a>
                                                    )
                                            }

                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            }
            {
                samplePosts.length > 0 &&
                <div className="app-card">
                    <h6 className="fs-16 text-dark fw-600">Sample Media Posts</h6>
                    <div className='specification-card-content'>
                        <div className="row mb-0 g-0">
                            {
                                samplePosts.map((samplePost, i) => {
                                    return (
                                        <div className="col-6 p-1" key={i}>
                                            {
                                                getMediaTypeFromURL(samplePost.url) === 'image' &&
                                                <div onClick={() => setSelectedMedia(samplePost)} className="sample-post bg-media bgc-content" style={{
                                                    backgroundImage: `url(${samplePost.url})`
                                                }}></div>
                                            }
                                            {
                                                getMediaTypeFromURL(samplePost.url) === 'video' &&
                                                <div onClick={() => setSelectedMedia(samplePost)} className="curson-pointer w-100 position-relative bgc-content sample-post overflow-hidden">
                                                    <video className='w-100 h-100' src={samplePost.url} playsInline
                                                        muted
                                                        preload="metadata"
                                                        onLoadedMetadata={(e) => {
                                                            e.currentTarget.currentTime = 0.1; // force thumbnail frame
                                                        }} />
                                                    <img className='ig-reel-icon' src={InstagramReelIconPNG} alt='IG Reel' />
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            }

            {
                acknowledgementRequired &&
                <React.Fragment>
                    <div className='d-flex align-items-center mt-4'>
                        <div className="gig-selection-checkbox-wrapper me-1">
                            <input type='checkbox' id='acknowledgement' className='form-check-input gig-selection-check-input' checked={acknowledged} onChange={() => setAcknowledged(!acknowledged)} />
                        </div>
                        <label className='acknowledgement-check-label fs-14 text-dark fw-400' htmlFor='acknowledgement'>I have read all the information</label>
                    </div>

                    <button onClick={() => acknowledge()} className="btn btn-primary w-100 my-3" disabled={!acknowledged || acknowledging}>{acknowledging ? 'Please wait...' : 'Acknowledge'}</button>
                </React.Fragment>
            }
            {
                showDisabledTooltip &&
                <div className="disabled-tip-wrapper">
                    <div className="disabled-tip">
                        Kindly read the entire specifications section before continuing.
                    </div>
                </div>
            }

        </div>
    )
}

export default Specifications